/*eslint-disable*/
import jump from 'jump.js'
import vsbl from 'vsbl'

export default klp => {
  const jumpLink = document.querySelector('.js-explore-klp')

  jumpLink.addEventListener('click', () => {
    jump('.klp-product-container', {
      offset: -75
    })
  })
}



// WEBPACK FOOTER //
// ./src/scripts/components/klp-1.js